import { defaultsDeep } from 'es-toolkit/compat';

import config from 'configs/app';

import { BBVISION_THEME } from '../bbvision/bbvision-theme';

const DEFAULT_THEME_COLORS = {
  bg: {
    primary: {
      // for some reason links to colors.white and colors.black variables are not working here
      // so we use hex values instead
      // but it is not the case for other colors
      // bbvision: 主内容区域背景（bg.primary）
      _light: { value: BBVISION_THEME.colors.bg.primary.light },
      _dark: { value: BBVISION_THEME.colors.bg.primary.dark },
    },
    body: {
      // bbvision: 页面背景（bg.body）
      _light: { value: BBVISION_THEME.colors.bg.body.light },
      _dark: { value: BBVISION_THEME.colors.bg.body.dark },
    },
    input: {
      // bbvision: input 背景（bg.input）
      _light: { value: BBVISION_THEME.colors.bg.input.light },
      _dark: { value: BBVISION_THEME.colors.bg.input.dark },
    },
    skeleton: {
      // bbvision: skeleton 背景（bg.skeleton）
      _light: { value: BBVISION_THEME.colors.bg.skeleton.light },
      _dark: { value: BBVISION_THEME.colors.bg.skeleton.dark },
    },
    secondary: {
      // bbvision: secondary container 背景（bg.secondary）
      _light: { value: BBVISION_THEME.colors.bg.secondary.light },
      _dark: { value: BBVISION_THEME.colors.bg.secondary.dark },
    },
    secondarySubtle: {
      // bbvision: 次级背景（bg.secondary.subtle / bg.secondarySubtle）
      _light: { value: BBVISION_THEME.colors.bg.secondarySubtle.light },
      _dark: { value: BBVISION_THEME.colors.bg.secondarySubtle.dark },
    },
    overlay: {
      subtle: {
        // bbvision: 轻量 hover/蒙层（bg.overlay.subtle）
        _light: { value: BBVISION_THEME.colors.bg.overlaySubtle.light },
        _dark: { value: BBVISION_THEME.colors.bg.overlaySubtle.dark },
      },
    },
    step: {
      indicator: {
        // bbvision: step/progress 指示（bg.step.indicator）
        _light: { value: BBVISION_THEME.colors.bg.stepIndicator.light },
        _dark: { value: BBVISION_THEME.colors.bg.stepIndicator.dark },
      },
    },
    state: {
      success: {
        subtle: {
          _light: { value: BBVISION_THEME.colors.bg.state.successSubtle.light },
          _dark: { value: BBVISION_THEME.colors.bg.state.successSubtle.dark },
        },
      },
      error: {
        subtle: {
          _light: { value: BBVISION_THEME.colors.bg.state.errorSubtle.light },
          _dark: { value: BBVISION_THEME.colors.bg.state.errorSubtle.dark },
        },
      },
      warning: {
        subtle: {
          _light: { value: BBVISION_THEME.colors.bg.state.warningSubtle.light },
          _dark: { value: BBVISION_THEME.colors.bg.state.warningSubtle.dark },
        },
        light: {
          _light: { value: BBVISION_THEME.colors.bg.state.warningLight.light },
          _dark: { value: BBVISION_THEME.colors.bg.state.warningLight.dark },
        },
      },
    },
  },
  text: {
    primary: {
      // bbvision: text.primary
      _light: { value: BBVISION_THEME.colors.text.primary.light },
      _dark: { value: BBVISION_THEME.colors.text.primary.dark },
    },
    secondary: {
      // bbvision: text.secondary
      _light: { value: BBVISION_THEME.colors.text.secondary.light },
      _dark: { value: BBVISION_THEME.colors.text.secondary.dark },
    },
    accent: {
      // bbvision: text.accent（选中态/强调色，需区分明暗模式）
      _light: { value: BBVISION_THEME.colors.text.accent.light },
      _dark: { value: BBVISION_THEME.colors.text.accent.dark },
    },
    muted: {
      // bbvision: text.muted（弱提示/placeholder）
      _light: { value: BBVISION_THEME.colors.text.muted.light },
      _dark: { value: BBVISION_THEME.colors.text.muted.dark },
    },
    state: {
      up: {
        _light: { value: BBVISION_THEME.colors.text.state.up.light },
        _dark: { value: BBVISION_THEME.colors.text.state.up.dark },
      },
      down: {
        _light: { value: BBVISION_THEME.colors.text.state.down.light },
        _dark: { value: BBVISION_THEME.colors.text.state.down.dark },
      },
      warning: {
        _light: { value: BBVISION_THEME.colors.text.state.warning.light },
        _dark: { value: BBVISION_THEME.colors.text.state.warning.dark },
      },
    },
  },
  hover: {
    // bbvision: 主要导航/链接 hover（text.accent.hover）
    _light: { value: BBVISION_THEME.colors.text.accentHover.light },
    _dark: { value: BBVISION_THEME.colors.text.accentHover.dark },
  },
  border: {
    'default': {
      // bbvision: border.default
      _light: { value: BBVISION_THEME.colors.border.default.light },
      _dark: { value: BBVISION_THEME.colors.border.default.dark },
    },
    state: {
      success: {
        _light: { value: BBVISION_THEME.colors.border.state.success.light },
        _dark: { value: BBVISION_THEME.colors.border.state.success.dark },
      },
      error: {
        _light: { value: BBVISION_THEME.colors.border.state.error.light },
        _dark: { value: BBVISION_THEME.colors.border.state.error.dark },
      },
      warning: {
        _light: { value: BBVISION_THEME.colors.border.state.warning.light },
        _dark: { value: BBVISION_THEME.colors.border.state.warning.dark },
      },
    },
  },
  table: {
    row: {
      hover: {
        bg: {
          _light: { value: BBVISION_THEME.colors.table.rowHoverBg.light },
          _dark: { value: BBVISION_THEME.colors.table.rowHoverBg.dark },
        },
      },
      divider: {
        _light: { value: BBVISION_THEME.colors.table.rowDivider.light },
        _dark: { value: BBVISION_THEME.colors.table.rowDivider.dark },
      },
    },
  },
  tooltip: {
    bg: {
      _light: { value: BBVISION_THEME.colors.tooltip.bg.light },
      _dark: { value: BBVISION_THEME.colors.tooltip.bg.dark },
    },
  },
  // icon.* 已在下方统一定义（避免重复 key）
  input: {
    border: {
      focus: {
        // bbvision: input.border.focus
        _light: { value: BBVISION_THEME.colors.border.input.focus.light },
        _dark: { value: BBVISION_THEME.colors.border.input.focus.dark },
      },
    },
  },
  selected: {
    control: {
      text: {
        // bbvision: 选中态文字（text.accent）
        _light: { value: BBVISION_THEME.colors.text.accent.light },
        _dark: { value: BBVISION_THEME.colors.text.accent.dark },
      },
      bg: {
        // bbvision: 选中态背景（bg.secondary）
        _light: { value: BBVISION_THEME.colors.bg.secondary.light },
        _dark: { value: BBVISION_THEME.colors.bg.secondary.dark },
      },
    },
    option: {
      bg: {
        // bbvision: 下拉/选项选中背景（bg.secondary）
        _light: { value: BBVISION_THEME.colors.bg.secondary.light },
        _dark: { value: BBVISION_THEME.colors.bg.secondary.dark },
      },
    },
  },
  icon: {
    primary: {
      _light: { value: '{colors.gray.500}' },
      _dark: { value: '{colors.gray.400}' },
    },
    secondary: {
      _light: { value: '{colors.gray.400}' },
      _dark: { value: '{colors.gray.500}' },
    },
    toast: {
      // bbvision: toast icon
      _light: { value: BBVISION_THEME.colors.icon.toast.light },
      _dark: { value: BBVISION_THEME.colors.icon.toast.dark },
    },
  },
  button: {
    primary: {
      _light: { value: '{colors.blue.600}' },
      _dark: { value: '{colors.blue.600}' },
    },
  },
  link: {
    primary: {
      // bbvision: 链接主色（text.accent）
      _light: { value: BBVISION_THEME.colors.text.accent.light },
      _dark: { value: BBVISION_THEME.colors.text.accent.dark },
    },
  },
  graph: {
    line: {
      // 统一所有图表折线颜色（含明暗模式）
      _light: { value: '#fcc53d' },
      _dark: { value: '#fcc53d' },
    },
    gradient: {
      start: {
        // 面积图填充（黄线氛围光），含明暗模式
        _light: { value: 'rgba(252, 197, 61, 0.22)' },
        _dark: { value: 'rgba(252, 197, 61, 0.22)' },
      },
      stop: {
        _light: { value: 'rgba(252, 197, 61, 0)' },
        _dark: { value: 'rgba(252, 197, 61, 0)' },
      },
    },
  },
  navigation: {
    bg: {
      selected: {
        // bbvision: 导航选中背景（bg.secondary）
        _light: { value: BBVISION_THEME.colors.bg.secondary.light },
        _dark: { value: BBVISION_THEME.colors.bg.secondary.dark },
      },
    },
    text: {
      selected: {
        // bbvision: 导航选中文字（text.accent）
        _light: { value: BBVISION_THEME.colors.text.accent.light },
        _dark: { value: BBVISION_THEME.colors.text.accent.dark },
      },
    },
  },
  stats: {
    bg: {
      _light: { value: '{colors.gray.50}' },
      _dark: { value: '{colors.whiteAlpha.100}' },
    },
  },
  topbar: {
    bg: {
      _light: { value: '{colors.gray.50}' },
      _dark: { value: '{colors.whiteAlpha.100}' },
    },
  },
  tabs: {
    text: {
      primary: {
        // bbvision: tab 文字主色（通常是选中/强调）
        _light: { value: BBVISION_THEME.colors.text.accent.light },
        _dark: { value: BBVISION_THEME.colors.text.accent.dark },
      },
    },
  },
};

const colors = {
  // BASE COLORS
  green: {
    '50': { value: '#F0FFF4' },
    '100': { value: '#C6F6D5' },
    '200': { value: '#9AE6B4' },
    '300': { value: '#68D391' },
    '400': { value: '#48BB78' },
    '500': { value: '#38A169' },
    '600': { value: '#25855A' },
    '700': { value: '#276749' },
    '800': { value: '#22543D' },
    '900': { value: '#1C4532' },
  },
  blue: {
    '50': { value: '#EBF8FF' },
    '100': { value: '#BEE3F8' },
    '200': { value: '#90CDF4' },
    '300': { value: '#63B3ED' },
    '400': { value: '#4299E1' },
    '500': { value: '#3182CE' },
    '600': { value: '#2B6CB0' },
    '700': { value: '#2C5282' },
    '800': { value: '#2A4365' },
    '900': { value: '#1A365D' },
  },
  red: {
    '50': { value: '#FFF5F5' },
    '100': { value: '#FED7D7' },
    '200': { value: '#FEB2B2' },
    '300': { value: '#FC8181' },
    '400': { value: '#F56565' },
    '500': { value: '#E53E3E' },
    '600': { value: '#C53030' },
    '700': { value: '#9B2C2C' },
    '800': { value: '#822727' },
    '900': { value: '#63171B' },
  },
  orange: {
    '50': { value: '#FFFAF0' },
    '100': { value: '#FEEBCB' },
    '200': { value: '#FBD38D' },
    '300': { value: '#F6AD55' },
    '400': { value: '#ED8936' },
    '500': { value: '#DD6B20' },
    '600': { value: '#C05621' },
    '700': { value: '#9C4221' },
    '800': { value: '#7B341E' },
    '900': { value: '#652B19' },
  },
  yellow: {
    '50': { value: '#FFFFF0' },
    '100': { value: '#FEFCBF' },
    '200': { value: '#FAF089' },
    '300': { value: '#F6E05E' },
    '400': { value: '#ECC94B' },
    '500': { value: '#D69E2E' },
    '600': { value: '#B7791F' },
    '700': { value: '#975A16' },
    '800': { value: '#744210' },
    '900': { value: '#5F370E' },
  },
  gray: {
    '50': { value: '#F7FAFC' },
    '100': { value: '#EDF2F7' },
    '200': { value: '#E2E8F0' },
    '300': { value: '#CBD5E0' },
    '400': { value: '#A0AEC0' },
    '500': { value: '#718096' },
    '600': { value: '#4A5568' },
    '700': { value: '#2D3748' },
    '800': { value: '#1A202C' },
    '900': { value: '#171923' },
  },
  teal: {
    '50': { value: '#E6FFFA' },
    '100': { value: '#B2F5EA' },
    '200': { value: '#81E6D9' },
    '300': { value: '#4FD1C5' },
    '400': { value: '#38B2AC' },
    '500': { value: '#319795' },
    '600': { value: '#2C7A7B' },
    '700': { value: '#285E61' },
    '800': { value: '#234E52' },
    '900': { value: '#1D4044' },
  },
  cyan: {
    '50': { value: '#EDFDFD' },
    '100': { value: '#C4F1F9' },
    '200': { value: '#9DECF9' },
    '300': { value: '#76E4F7' },
    '400': { value: '#0BC5EA' },
    '500': { value: '#00B5D8' },
    '600': { value: '#00A3C4' },
    '700': { value: '#0987A0' },
    '800': { value: '#086F83' },
    '900': { value: '#065666' },
  },
  purple: {
    '50': { value: '#FAF5FF' },
    '100': { value: '#E9D8FD' },
    '200': { value: '#D6BCFA' },
    '300': { value: '#B794F4' },
    '400': { value: '#9F7AEA' },
    '500': { value: '#805AD5' },
    '600': { value: '#6B46C1' },
    '700': { value: '#553C9A' },
    '800': { value: '#44337A' },
    '900': { value: '#322659' },
  },
  pink: {
    '50': { value: '#FFF5F7' },
    '100': { value: '#FED7E2' },
    '200': { value: '#FBB6CE' },
    '300': { value: '#F687B3' },
    '400': { value: '#ED64A6' },
    '500': { value: '#D53F8C' },
    '600': { value: '#B83280' },
    '700': { value: '#97266D' },
    '800': { value: '#702459' },
    '900': { value: '#521B41' },
  },
  black: { value: '#101112' },
  white: { value: '#ffffff' },
  whiteAlpha: {
    '50': { value: 'RGBA(255, 255, 255, 0.04)' },
    '100': { value: 'RGBA(255, 255, 255, 0.06)' },
    '200': { value: 'RGBA(255, 255, 255, 0.08)' },
    '300': { value: 'RGBA(255, 255, 255, 0.16)' },
    '400': { value: 'RGBA(255, 255, 255, 0.24)' },
    '500': { value: 'RGBA(255, 255, 255, 0.36)' },
    '600': { value: 'RGBA(255, 255, 255, 0.48)' },
    '700': { value: 'RGBA(255, 255, 255, 0.64)' },
    '800': { value: 'RGBA(255, 255, 255, 0.80)' },
    '900': { value: 'RGBA(255, 255, 255, 0.92)' },
  },
  blackAlpha: {
    '50': { value: 'RGBA(16, 17, 18, 0.04)' },
    '100': { value: 'RGBA(16, 17, 18, 0.06)' },
    '200': { value: 'RGBA(16, 17, 18, 0.08)' },
    '300': { value: 'RGBA(16, 17, 18, 0.16)' },
    '400': { value: 'RGBA(16, 17, 18, 0.24)' },
    '500': { value: 'RGBA(16, 17, 18, 0.36)' },
    '600': { value: 'RGBA(16, 17, 18, 0.48)' },
    '700': { value: 'RGBA(16, 17, 18, 0.64)' },
    '800': { value: 'RGBA(16, 17, 18, 0.80)' },
    '900': { value: 'RGBA(16, 17, 18, 0.92)' },
  },

  // BRAND COLORS
  github: { value: '#171923' },
  telegram: { value: '#2775CA' },
  linkedin: { value: '#1564BA' },
  discord: { value: '#9747FF' },
  slack: { value: '#1BA27A' },
  twitter: { value: '#000000' },
  opensea: { value: '#2081E2' },
  facebook: { value: '#4460A0' },
  medium: { value: '#231F20' },
  reddit: { value: '#FF4500' },
  celo: { value: '#FCFF52' },
  clusters: { value: '#DE6061' },

  // THEME COLORS
  theme: defaultsDeep(config.UI.colorTheme.overrides, DEFAULT_THEME_COLORS),
};

export default colors;
